<i18n>
{
  "en": {
    "forgot": {
      "cta": "Send new password",
      "messages": {
        "success": "New password was succesfully sent to given e-mail"
      }
    }
  }
}
</i18n>

<template>
  <div class="forgot">
    <field
      v-model="object['email']"
      :field="{ placeholder: 'Email' }"
    ></field>
    <button
      class="btn btn-success"
      @click="send"
    >
      {{ $t('forgot.cta') }}
    </button>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import Field from '@/components/Field';

export default {
  name: 'login',
  components: {
    Field,
  },
  computed: {
    ...mapState({
      authenticated: state => state.auth.authenticated,
    }),
  },
  data() {
    return {
      loading: false,
      object: {
        email: null,
      },
    };
  },
  created() {
    this.$store.dispatch('breadcrumbs/reset');
  },
  methods: {
    send() {
      this.$http
        .get(
          `${process.env.VUE_APP_API}/users/forgot?email=${this.object.email}`,
        )
        .then(data => {
          if (data && data.data && data.data.type === 'error') {
            this.$error(data.data.msg);
          } else {
            this.$success(this.$t('forgot.messages.success'));
          }
        });
    },
  },
};
</script>
